import { StoryTranslationType } from "../../features/story.types";

export const story: StoryTranslationType = {
  success: {
    charactersSaved: "角色已保存",
    charactersAddedToLibrary: "角色已添加到库"
  },
  storySetup: {
    titles: {
      new: "创建新故事",
      edit: "编辑故事",
      continue: "继续故事"
    },
    basicInfo: {
      storyTitle: "故事标题",
      titlePlaceholder: "输入故事标题",
      silverLining: "故事精髓",
      descriptionPlaceholder: "你的故事真正讲述的是什么？这将有助于引导叙事。",
      genre: "体裁",
      selectGenre: "选择体裁",
      environment: "环境",
      selectEnvironment: "选择环境",
      theme: "主题",
      storyLength: "故事长度",
      storyLengthWithNumberOfPages: "故事长度（页数）",
      selectLength: "选择长度",
      aiSuggest: "AI建议",
      missingValues: "缺失值",
      fillRequired: "请填写所有必填字段",
      titleGenerated: "已生成标题",
      generationError: "生成错误",
      tryAgain: "请重试",
      addCustomGenre: "添加自定义体裁...",
      addCustomEnvironment: "添加自定义环境...",
      addCustomTheme: "添加自定义主题...",
      autoGenerate: "自动生成",
      formDataGenerated: "表单数据已生成",
      dataUpdated: "数据已更新",
      formDataEnhanced: "表单数据已增强",
      noEnhancementsNeeded: "不需要增强",
      formDataUpToDate: "表单数据已更新",
      needSomeInfo: "我们需要一些信息来开始"
    },
    genres: {
      fantasy: "奇幻",
      scienceFiction: "科幻",
      mystery: "悬疑",
      romance: "爱情",
      adventure: "冒险",
      horror: "恐怖",
      historicalFiction: "历史小说",
      contemporary: "当代",
      superhero: "超级英雄",
      kidsStory: "儿童故事",
      thriller: "惊悚"
    },
    environments: {
      urbanCity: "城市",
      medievalCastle: "中世纪城堡",
      spaceStation: "太空站",
      forest: "森林",
      desert: "沙漠",
      ocean: "海洋",
      mountain: "山脉",
      smallTown: "小镇",
      futuristicMetropolis: "未来都市",
      underwaterKingdom: "水下王国",
      hauntedMansion: "闹鬼宅邸",
      mountainCavern: "山洞",
      dragonLair: "龙穴",
      researchLaboratory: "研究实验室",
      futureCommunications: "未来通讯",
      magicalLibrary: "魔法图书馆",
      rainyNight: "雨夜",
      ancientTemple: "古代神庙"
    },
    storyLengths: {
      short: "短篇",
      medium: "中篇",
      long: "长篇",
      natural: "自然"
    },
    characters: {
      name: "角色名称",
      description: "角色描述",
      title: "角色",
      browseCharacters: "浏览角色",
      makePublic: "公开角色"
    },
    character: {
      name: "角色名称",
      namePlaceholder: "输入角色名称",
      role: "角色定位",
      selectRole: "选择角色定位",
      description: "角色描述",
      descriptionPlaceholder: "输入角色描述",
      create: "创建角色",
      update: "更新角色",
      roles: {
        protagonist: "主角",
        antagonist: "反派",
        deuteragonist: "配角",
        mentor: "导师",
        comic_relief: "喜剧角色",
        mysterious: "神秘人物",
        love_interest: "恋爱对象",
        anti_hero: "反英雄",
        sidekick: "助手",
        shapeshifter: "变形者",
        guardian: "守护者",
        catalyst: "催化剂"
      }
    },
    themeSection: {
      title: "主题"
    },
    themeOptions: {
      friendship: "友情",
      love: "爱情",
      betrayal: "背叛",
      redemption: "救赎",
      growth: "成长",
      power: "权力",
      justice: "正义",
      family: "家庭",
      courageBravery: "勇气与胆量",
      magicMythology: "魔法与神话",
      survival: "生存",
      warConflict: "战争与冲突",
      freedomRebellion: "自由与反抗",
      violenceRevenge: "暴力与复仇",
      passionEroticism: "激情与情色",
      quest: "探索",
      ancientWisdom: "远古智慧",
      timeTravel: "时间旅行",
      technology: "科技",
      paradox: "矛盾",
      knowledge: "知识",
      magic: "魔法",
      discovery: "发现",
      identity: "身份",
      sacrifice: "牺牲",
      transformation: "转变"
    },
    buttons: {
      create: "创建故事",
      update: "更新故事"
    },
    success: {
      title: "故事设置完成",
      description: "您的故事已成功创建，准备开始您的创作之旅。"
    },
    failure: {
      title: "故事设置失败",
      description: "创建故事时发生错误。请检查您的输入并重试。",
    },
  },
  story: {
    parts: "部分",
    part: "部分",
    continueStory: "继续故事",
    print: "打印",
    generatingSummary: "生成摘要",
    generatingContinuation: "生成续集",
    pleaseWait: "请稍候...",
    backToDashboard: "返回仪表板",
    extractCharacters: "提取角色",
    foundCharacters: "发现的角色",
    addSelectedCharacters: "添加选定的角色",
    share: "分享",
    viewEntire: "查看完整故事",
    viewPaginated: "查看分页",
    tooltips: {
      upgradeToContinue: "升级以继续故事",
      upgradeToShare: "升级以分享故事",
      upgradeToExtract: "升级以提取角色"
    },
    ratings: {
      submitted: "评分已提交",
      thankYou: "感谢您对这个故事的评分！",
      error: "错误",
      failedToSubmit: "评分提交失败"
    },
    sharing: {
      dialogTitle: "分享您的故事",
      dialogDescription: "选择您想分享故事的平台",
      privacy: "故事隐私",
      privacyLevels: {
        private: "私密",
        public: "公开",
        friends: "仅好友"
      },
      platform: "平台",
      selectPlatform: "选择平台",
      customMessage: "自定义消息",
      customMessagePlaceholder: "为您的分享添加消息...",
      shareButton: "分享故事",
      successTitle: "故事分享成功",
      successMessage: "您的故事已分享到 {{platform}}",
      authRequired: "需要认证",
      authMessage: "请登录以分享故事。"
    },
    upgrade: {
      title: "需要升级",
      continueDescription: "升级您的账户以创建故事序列。",
      continueFeature: "通过高级订阅创建故事序列",
      shareDescription: "升级您的账户以分享故事。",
      shareFeature: "通过基础订阅分享故事",
      extractDescription: "升级您的账户以提取角色。",
      extractFeature: "通过高级订阅提取角色",
      upgradeButton: "立即升级"
    }
  },
  storyEditor: {
    navigation: {
      previousPage: "上一页",
      continue: "继续",
      returnToDashboard: "返回仪表板",
      page: "页",
      of: "的",
      remainingPages: "剩余页面",
    },
    input: {
      customResponse: "自定义回应"
    },
    choices: {
      yourChoice: "您的选择"
    },
    completedStory: {
      title: "故事已完成",
      description: "您的故事已达到结局！",
    },
  },
  imageGeneration:{
    ready: "准备就绪",
    imageReady: "图像已准备好",
    insufficientCredits: "积分不足",
    needMoreCredits: "需要更多积分",
    failed: "失败",
    processing: "处理中",
    pleaseWait: "请稍候",
    unexpectedError: "意外错误",
    generateImage: "生成图像",
    costsCredits: "消耗积分",
    generatingImage: "生成图像中",
    credits: "积分",
    creditsLabel: "积分",
    selectImage: "选择图像",
    selectImageDescription: "选择图像以展示事件",
    selectPreferred: "选择首选图像",
    contentNotFound: "内容未找到",
    saved: "图像已保存",
    imageSaved: "图像已保存",
    partialSuccess: "部分成功",
    someImagesFailed: "一些图像生成失败",
  },
  audioGeneration: {
    insufficientCredits: "积分不足",
    generateAudio: "生成音频",
    generatingAudio: "生成音频中",
    pleaseWait: "请稍候",
    failed: "失败",
    success: "成功",
    audioReady: "音频已准备好",
    audioAvailable: "音频可用"
  },
  storyRewrite:{
    rewritesLeft: "剩余重写次数",
    rewriteStory: "重写故事",
    rewriteComplete: "故事重写完成",
    refreshingContent: "正在刷新内容",
    refreshError: "刷新错误",
    refreshErrorMessage: "刷新故事时发生意外错误。请重试。",
    noRewritesLeft: "没有剩余的重写次数",
    tryPageRefresh: "尝试刷新页面",
  },
  loadingMessages: {
    craftingTheNextChapter: "正在编写下一个章节",
    weavingThePlotTwists: "编织情节转折",
    yourAdventureIsAboutToUnfold: "您的冒险即将展开",
    developingTheCharacters: "正在发展角色",
    imaginingNewPossibilities: "想象新的可能性",
  },
};
